import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';
import {
  getPremiumMarkets,
  addExchangeBet,
  getCurrencyTypeFromToken,
} from '../../store';
import './PremiumMarkets.scss';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@material-ui/core';
import ExpandLessSharpIcon from '@material-ui/icons/ExpandLessSharp';

// import Modal from '@material-ui/core/Modal';
import ExchOddBtn from '../ExchOddButton/ExchOddButton';
import { UserBet } from '../../models/UserBet';
import InfoImg from '../../assets/images/sportsbook/info.svg';
import moment from 'moment';
import { SelectedObj } from '../../models/ExchangeSportsState';
import { EventDTO } from '../../models/common/EventDTO';
import MarketTermsCondi from '../../components/MarketTermsCondi/MarketTermsCondi';
import Modal from '../../components/Modal/Modal';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import { PlaceBetRequest } from '../../models/BsData';
import { MatchOdds, SPEventDTO, Runner } from '../../models/common/SPEventDTO';
import Betslip from '../../components/ExchBetslip/ExchBetslip';
import API from '../../api';
import { MarketLimitDTO } from '../../models/common/MarketLimitDto';
import { IonIcon } from '@ionic/react';
import CricketPreMatchRules from './CricketPreMatchRules.pdf';
import CricketInplayRules from './CricketInplayRules.pdf';
import SoccerInplayRules from './soccer-inplay.pdf';
import SoccerPreMatchRules from './soccer-pre-match.pdf';
import TennisInplayRules from './tennis-inplay.pdf';
import TennisPreMatchRules from './tennis-pre-match.pdf';
import { PictureAsPdfOutlined } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';

type OddsInfoMsg = {
  launch: boolean;
  oddsType: string;
  eventTypeID: string;
};

type StoreProps = {
  dreamData: EventDTO;
  eventData: SPEventDTO;
  bets: PlaceBetRequest[];
  openBets: UserBet[];
  addExchangeBet: (data: PlaceBetRequest) => void;
  selectedEventType: SelectedObj;
  loggedIn: boolean;
  getFormattedMinLimit: (num: number) => string;
  getFormattedMaxLimit: (num: number) => string;
};

const PremiumMarketsView: React.FC<StoreProps> = (props) => {
  const {
    eventData,
    dreamData,
    bets,
    openBets,
    addExchangeBet,
    selectedEventType,
    loggedIn,
  } = props;
  const [premiumMarkets, setPremiummarkets] = useState<MatchOdds[]>();
  const disabledStatus = [
    'deactivated',
    'suspended',
    'closed',
    'suspended-manually',
  ];
  const [minStake, setMinStake] = useState<number>(500);
  const [maxStake, setMaxStake] = useState<number>(50000);
  const [limits, setLimits] = useState<MarketLimitDTO>({});
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];
  const [selectedRow, setSelectedRow] = useState<string>('');

  const [infoDilalog, setInfoDialog] = useState<OddsInfoMsg>({
    launch: false,
    oddsType: null,
    eventTypeID: null,
  });

  const sportInplayRulesMap = {
    '4': [CricketInplayRules, CricketPreMatchRules],
    'sr:sport:21': [CricketInplayRules, CricketPreMatchRules],
    '1': [SoccerInplayRules, SoccerPreMatchRules],
    'sr:sport:1': [SoccerInplayRules, SoccerPreMatchRules],
    '2': [TennisInplayRules, TennisPreMatchRules],
    'sr:sport:5': [TennisInplayRules, TennisPreMatchRules],
  };

  useEffect(() => {
    if (eventData) {
      setPremiummarkets(eventData.markets.matchOdds);
    }
  }, [eventData]);

  const getOpenBetsPL = (marketId: string, runner: Runner) => {
    let returns = null;
    const mOpenBets = openBets.filter(
      (b) => b.marketType === 0 && b.marketId === marketId
    );
    for (let bet of mOpenBets) {
      const plVal = bet.oddValue * bet.stakeAmount - bet.stakeAmount;
      if (bet.betType === 0) {
        if (bet.outcomeId === runner.runnerId) {
          returns ? (returns += plVal) : (returns = plVal);
        } else {
          returns
            ? (returns -= bet.stakeAmount)
            : (returns = 0 - bet.stakeAmount);
        }
      } else if (bet.betType === 1) {
        if (bet.outcomeId !== runner.runnerId) {
          returns ? (returns += bet.stakeAmount) : (returns = bet.stakeAmount);
        } else {
          returns ? (returns -= plVal) : (returns = 0 - plVal);
        }
      }
    }
    const retVal = returns ? returns / cFactor : null;
    return retVal;
  };

  const getOpenBetsPLInArray = (marketId: string, runner: Runner) => {
    return [getOpenBetsPL(marketId, runner)];
  };

  const getTotalPL = (marketId: string, runner: Runner) => {
    let returns = null;
    const mBetslipBets = bets.filter(
      (b) => b.marketId === marketId && b.amount && b.amount > 0
    );
    if (mBetslipBets.length > 0) {
      returns = getOpenBetsPL(marketId, runner);
      for (let bet of mBetslipBets) {
        const plVal = bet.oddValue * bet.amount - bet.amount;
        if (bet.betType === 'BACK') {
          if (bet.outcomeId === runner.runnerId) {
            returns ? (returns += plVal) : (returns = plVal);
          } else {
            returns ? (returns -= bet.amount) : (returns = 0 - bet.amount);
          }
        } else if (bet.betType === 'LAY') {
          if (bet.outcomeId !== runner.runnerId) {
            returns ? (returns += bet.amount) : (returns = bet.amount);
          } else {
            returns ? (returns -= plVal) : (returns = 0 - plVal);
          }
        }
      }
    }
    return [returns];
  };

  const fetchBetLimits = async () => {
    try {
      const payload = {
        sportId: eventData.sportId,
        competitionId: eventData.competitionId,
        eventId: eventData.eventId,
        marketType: 'PREMIUM',
        marketId: '-',
        outcomeDesc: 'premium',
        mcategory: null,
      };
      let response;
      if (sessionStorage.getItem('jwt_token')) {
        response = await API.post('/bs/fetch-market-limits', payload, {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        });
      } else {
        response = await API.post('/bs/fetch-market-limits', payload);
      }
      if (response.status === 200 && response.data.success) {
        setLimits({
          ...limits,
          minStake: response.data.limits.minStake,
          maxStake: response.data.limits.maxStake,
          maxOdd: response.data.limits.maxOdd,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (eventData?.providerName =="SportRadar" || dreamData?.enablePremium) {
      fetchBetLimits();
    }
  }, [eventData]);

  return (
    <>
      <div className="premium-markets-table-ctn">
        <div className="pm-table-content table-ctn">
        <div className="premium-rules-header">
                      <span>
                        premium
                            <IonIcon
                          onClick={() =>
                            setInfoDialog({
                              launch: true,
                              oddsType: 'Fancy',
                              eventTypeID: eventData.sportId,
                            })
                          }
                          className="info-img"
                          src={InfoImg}
                        />
                      </span>
                    </div>
          {premiumMarkets && premiumMarkets.length > 0 ? (
            <>
              {premiumMarkets.map((pm, idx) =>
                pm && pm.runners.length > 0 ? (
                  <Accordion
                    defaultExpanded={true}
                    className="markets-accordian"
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandLessSharpIcon className="expand-icon" />
                      }
                      aria-controls="panel1a-content"
                    >
                      <div className="market-name">{pm?.marketName}</div>
                    </AccordionSummary>

                    <AccordionDetails>
                      <TableContainer>
                        <Table className="pm-table">
                          <TableBody>
                            {pm.runners.map((runner, index) => (
                              <PremiumMarketRow
                                eventData={eventData}
                                dreamData={dreamData}
                                matchOddsData={pm}
                                runner={runner}
                                getOpenBetsPL={getOpenBetsPLInArray}
                                getTotalPL={getTotalPL}
                                disabledStatus={disabledStatus}
                                addExchangeBet={addExchangeBet}
                                bets={bets}
                                selectedRow={selectedRow}
                                setSelectedRow={setSelectedRow}
                                limits={limits}
                              />
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </AccordionDetails>
                  </Accordion>
                ) : null
              )}
            </>
          ) : null}
          <Modal
            open={infoDilalog.launch}
            closeHandler={() =>
              setInfoDialog({
                launch: false,
                oddsType: null,
                eventTypeID: null,
              })
            }
            customClass="light-bg-title"
            title="Rules"
            size="md"
          >
            <MarketTermsCondi
              oddsType={infoDilalog.oddsType}
              eventTypeID={infoDilalog.eventTypeID}
            />
          </Modal>
          <Dialog
            open={infoDilalog?.launch}
            onClose={() => setInfoDialog({ ...infoDilalog, launch: false })}
            aria-labelledby="Settlements Dialog"
            fullScreen={false}
            fullWidth={true}
            maxWidth="md"
            className="stl-dialog rules-dialog"
          >
            <DialogTitle className="stl-dialog-title">
              <div className="title-close-icon">
                <IconButton
                  className="close-btn"
                  onClick={() =>
                    setInfoDialog({ ...infoDilalog, launch: false })
                  }
                >
                  <CloseIcon className="close-icon" />
                </IconButton>
              </div>
            </DialogTitle>

            <DialogContent className="stl-dialog-content premium-rules-pdf-ctn">
              {sportInplayRulesMap[eventData?.sportId]?.map((file, idx) => (
                <a href={file} className="premium-rules-pdf" target="_blank">
                  <PictureAsPdfOutlined />
                  {idx === 0
                    ? ` Inplay `
                    : `Pre-Match `}{' '}
                  Rules
                </a>
              ))}
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </>
  );
};

type PremiumMarketRowProps = {
  eventData: SPEventDTO;
  dreamData: EventDTO;
  matchOddsData: MatchOdds;
  runner: Runner;
  getOpenBetsPL: (marketId: string, runner: Runner, type: string) => number[];
  getTotalPL: (marketId: string, runner: Runner) => number[];
  disabledStatus: string[];
  addExchangeBet: (data: PlaceBetRequest) => void;
  bets: PlaceBetRequest[];
  selectedRow: string;
  setSelectedRow: (data) => void;
  limits: MarketLimitDTO;
};

const PremiumMarketRow: React.FC<PremiumMarketRowProps> = (props) => {
  const {
    eventData,
    dreamData,
    matchOddsData,
    runner,
    getOpenBetsPL,
    getTotalPL,
    disabledStatus,
    addExchangeBet,
    bets,
    selectedRow,
    setSelectedRow,
    limits
  } = props;
  return (
    <>
      <TableRow>
        <TableCell className="team-name-cell">
          <div className="team">
            {runner.runnerName}
            {getOpenBetsPL(matchOddsData.marketId, runner, 'array').map((ret) =>
              ret !== null ? (
                <span className={ret >= 0 ? 'profit' : 'loss'}>
                  {ret > 0
                    ? '+' + Number(ret).toFixed(2)
                    : Number(ret).toFixed(2)}
                </span>
              ) : null
            )}
          </div>
          <div>
            {getTotalPL(matchOddsData.marketId, runner).map((ret) =>
              ret !== null ? (
                <span className={ret >= 0 ? 'profit' : 'loss'}>
                  {ret > 0
                    ? '+' + Number(ret).toFixed(2)
                    : Number(ret).toFixed(2)}
                </span>
              ) : null
            )}
          </div>
        </TableCell>

        <TableCell className="odds-cell" align="right">
          <div className="odds-block web-view back-odds-block premium-odds-block">
            {runner.backPrices.length > 0 ? (
              runner.backPrices.map((odds, idx) => (
                <ExchOddBtn
                  mainValue={odds.price}
                  subValue={null}
                  showSubValueinKformat={true}
                  oddType="premium-odd"
                  valueType="matchOdds"
                  oddsSet={[
                    runner.backPrices[0] ? runner.backPrices[0].price : 0,
                    runner.backPrices[1] ? runner.backPrices[1].price : 0,
                    runner.backPrices[2] ? runner.backPrices[2].price : 0,
                  ]}
                  key={idx}
                  disable={
                    disabledStatus.includes(
                      matchOddsData.status.toLowerCase()
                    ) || disabledStatus.includes(eventData.status.toLowerCase())
                  }
                  onClick={() => {
                    addExchangeBet({
                      sportId: dreamData.sportId,
                      seriesId: dreamData.competitionId,
                      seriesName: eventData.competitionName,
                      eventId: dreamData.eventId,
                      eventName: eventData.eventName,
                      eventDate: +eventData.openDate,
                      marketId: matchOddsData.marketId,
                      marketName: matchOddsData.marketName,
                      marketType: 'PREMIUM',
                      outcomeId: runner.runnerId,
                      outcomeDesc: runner.runnerName,
                      betType: 'BACK',
                      amount: 0,
                      oddValue: runner.backPrices[idx].price,
                      sessionPrice: -1,
                      srEventId: eventData.eventId,
                      srSeriesId: eventData.competitionId,
                      srSportId: eventData.sportId,
                    });
                  }}
                />
              ))
            ) : (
              <></>
            )}
          </div>

          <div className="odds-block mob-view back-odds-block premium-odds-block">
            <ExchOddBtn
              mainValue={runner.backPrices[0]?.price}
              subValue={null}
              showSubValueinKformat={true}
              oddType="premium-odd"
              valueType="matchOdds"
              disable={
                disabledStatus.includes(matchOddsData.status.toLowerCase()) ||
                moment(eventData?.openDate).diff(moment(), 'minutes') >
                  60 * 24 * 2
              }
              onClick={() => {
                setSelectedRow(runner.runnerName + 'PREMIUM');
                addExchangeBet({
                  sportId: dreamData.sportId,
                  seriesId: dreamData.competitionId,
                  seriesName: eventData.competitionName,
                  eventId: dreamData.eventId,
                  eventName: eventData.eventName,
                  eventDate: eventData.openDate,
                  marketId: matchOddsData.marketId,
                  marketName: matchOddsData.marketName,
                  marketType: 'PREMIUM',
                  outcomeId: runner.runnerId,
                  outcomeDesc: runner.runnerName,
                  betType: 'BACK',
                  amount: 0,
                  oddValue: runner.backPrices[0].price,
                  sessionPrice: -1,
                  srEventId: eventData.eventId,
                  srSeriesId: eventData.competitionId,
                  srSportId: eventData.sportId,
                });
              }}
            />
          </div>
        </TableCell>
        <TableCell className="limits-cell">
          <div>
            <div>Min: {limits?.minStake || 0}</div>
            <div>Max: {limits?.maxStake || 0}</div>
          </div>
        </TableCell>
      </TableRow>

      {bets?.[0]?.marketName === matchOddsData.marketName &&
      selectedRow === runner.runnerName + 'PREMIUM' ? (
        <TableRow className="mob-view">
          <TableCell colSpan={3}>
            <Betslip mobileView={true} />{' '}
          </TableCell>
        </TableRow>
      ) : null}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  const eventType = state.exchangeSports.selectedEventType;
  const event = state.exchangeSports.selectedEvent;
  return {
    eventData: getPremiumMarkets(
      state.exchangeSports.premiumMarketsMap,
      event.id
    ),
    selectedEventType: eventType,
    bets: state.exchBetslip.bets,
    openBets: state.exchBetslip.openBets,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: PlaceBetRequest) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PremiumMarketsView);
